// GENERATED by scripts/gen-event-codemap.mjs from schemas/v2/event-codemap.json — do not edit.
// Corpus tag: v2.46.41. Re-run after scripts/sync-schemas.sh; eventVocabulary.test.ts fails on drift.
export const EVENT_CODEMAP_CORPUS_TAG = "v2.46.41";
/** Renamed event types only: [v1 spelling, v2 spelling]. Identity rows are omitted. */
export const RENAMED_EVENT_TYPES: ReadonlyArray<readonly [string, string]> = [
  ["agent.invocation.completed", "agent.invocation-completed"],
  ["agent.invocation.started", "agent.invocation-started"],
  ["agent.memory.consolidated", "agent.memory-consolidated"],
  ["agent.promptResolved", "agent.prompt-resolved"],
  ["agent.reasoning.delta", "agent.reasoning-delta"],
  ["agent.toolCalled", "agent.tool-called"],
  ["agent.toolReturned", "agent.tool-returned"],
  ["budget.threshold.crossed", "budget.threshold-crossed"],
  ["compensation.manual_intervention_required", "compensation.manual-intervention-required"],
  ["connector.auth_expired", "connector.auth-expired"],
  ["core.dispatch.fanOut", "dispatch.fanned-out"],
  ["core.dispatch.join", "dispatch.joined"],
  ["core.workflowChain.confidence-escalated", "workflow-chain.confidence-escalated"],
  ["core.workflowChain.event", "workflow-chain.event"],
  ["deployment.canary.adjusted", "deployment.canary-adjusted"],
  ["deployment.state.changed", "deployment.state-changed"],
  ["envelope.nlToFormat.engaged", "envelope.nl-to-format-engaged"],
  ["envelope.recovery.applied", "envelope.recovery-applied"],
  ["envelope.retry.attempted", "envelope.retry-attempted"],
  ["envelope.retry.exhausted", "envelope.retry-exhausted"],
  ["model.capability.insufficient", "model.capability-insufficient"],
  ["model.capability.substituted", "model.capability-substituted"],
  ["replay.divergedAtRefusal", "replay.diverged-at-refusal"],
  ["roster.run.initiated", "roster.run-initiated"],
  ["run.dead_lettered", "run.dead-lettered"],
  ["run.resuming", "run.resume-started"],
  ["runOrchestrator.decided", "orchestrator.decided"],
  ["tool.session.closed", "tool.session-closed"],
  ["tool.session.opened", "tool.session-opened"],
  ["trigger.delivery.attempted", "trigger.delivery-attempted"],
  ["trigger.subscription.state.changed", "trigger.subscription-state-changed"],
  ["voice.barge_in", "voice.barge-in"],
  ["voice.endpoint_candidate", "voice.endpoint-candidate"],
  ["voice.speech_start", "voice.speech-start"],
  ["voice.synthesis_chunk", "voice.synthesis-chunk"],
  ["voice.turn_commit", "voice.turn-commit"],
];
